<div *commonUiOptionalWizardStep>

  <div class="pt-1 mb-1x">
    <div class="d-flex justify-content-between">
      <h2>{{ 'COMMON_UI.FRAGEBOGEN.GESETZLICHER_VERTRETER.TITEL' | translate }}</h2>
      <common-ui-daten-uebernahme (picked)="onGesetzlicheVertreterPicked($event)"
                                  *ngIf="data?.gesetzlicheVertreter?.length < 9"
                                  [itemTemplate]="datenuebernahmeGesetzlicherVertreter"
                                  [items]="stammdaten?.gesetzlicherVertreter"
                                  [readonly]="readonly"
                                  context="GesetzlicherVertreter"></common-ui-daten-uebernahme>
    </div>
  </div>

  <div *ngIf="showMaxLimitHint" class="col-sm-12 col-lg-12 p-0">
    <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.MAX_LIMIT_HINT' | translate"
                    type="info">
    </common-ui-card>
  </div>

  <div *ngIf="data?.gesetzlicheVertreter?.length < 1" class="col-sm-12 col-lg-12 p-0"
       id="gesetzlicheVertreterCountMessage">
    <common-ui-card [message]="'COMMON_UI.VALIDATION.GESETZLICHER_VERTRETER_LENGTH' | translate"
                    type="danger"></common-ui-card>
  </div>

  <div class="form-row mt-3x">
    <button (click)="addGesetzlicherVertreter()" *ngIf="!readonly && data?.gesetzlicheVertreter?.length < 9"
            class="btn btn-light ml-2 mb-2"
            id="addGesetzlicherVertreter"
            title="{{ 'COMMON_UI.FRAGEBOGEN.GESETZLICHER_VERTRETER.ADD_GESETZLICHER_VERTRETER' | translate }}">
      <em class="icon icon-svg icon-fi-hinzufuegen"></em>
      {{ 'COMMON_UI.FRAGEBOGEN.GESETZLICHER_VERTRETER.ADD_GESETZLICHER_VERTRETER' | translate }}
    </button>
  </div>

  <div class="mb-5x">

    <ul class="list-group d-flex" id="gesetzlicheVertreterList">
      <ng-container *ngFor="let gesetzlicherVertreter of data.gesetzlicheVertreter; let i = index">
        <li
          (click)="toggleSelect(i)"
          (keypress)="toggleSelect(i)"
          [ngClass]="{'list-group-item-selected': selectedIndex == i}" class="list-group-item common-ui-list-group-item"
          [tabIndex]="0"
          id="gesetzlicheVertreter{{i}}">
          <div
            [innerText]="getDescription(gesetzlicherVertreter)"
            [ngClass]="{'active': selectedIndex === i }"
            class="h5 list-group-item-heading ml-2x mb-0 list-item-title"
            id="gesetzlicheVertreterDescription{{i}}">
          </div>
          <div class="common-ui-remove-element">
            <button (click)="removeGesetzlicherVertreter(i)" *ngIf="!readonly && data?.gesetzlicheVertreter?.length > 0"
                    class="btn btn-light btn-img"
                    id="removeGesetzlicherVertreter{{i}}"
                    title="{{ 'COMMON_UI.FRAGEBOGEN.GESETZLICHER_VERTRETER.REMOVE_GESETZLICHER_VERTRETER' | translate }}">
              <em class="icon icon-svg icon-fi-loeschen"></em>
            </button>
          </div>
        </li>
        <div
          [ngClass]="(selectedIndex === i) ? 'display-list-item-form' : 'hide-list-item-form'"
          class="containing-form">
          <common-ui-gesetzlicher-vertreter-form
            [gesetzlicherVertreter]="gesetzlicherVertreter"
            [readonly]="readonly"
            [stammdaten]="stammdaten?.gesetzlicherVertreter">
          </common-ui-gesetzlicher-vertreter-form>
        </div>
      </ng-container>
    </ul>
  </div>
</div>

<ng-template #datenuebernahmeGesetzlicherVertreter let-item="item">
  <h4
    class="list-group-item-heading">{{item?.value.personenstammDaten?.vorname}} {{item?.value.personenstammDaten?.nachname}}</h4>
</ng-template>
